<template>
  <div>
    <v-card elevation="1" max-width="90%" class="profile-data">
      <v-card-text>
        <div
          class="mb-4"
          v-if="edit == false"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn class="primary-btn mb-4 edit-btn" @click="openEditMode()">
            {{ $t("Edit Details") }}
          </v-btn>
        </div>

        <div class="details">
          <div class="d-block d-sm-none addEditProfileImage">
            <EditDeleteProfileImage :general="general"></EditDeleteProfileImage>
          </div>
          <v-form v-model="valid" ref="form">
            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("name") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>{{ general.first_name }}</p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == true" class="input-td">
                <v-text-field
                  :rules="[validationRules.required, validationRules.spaces]"
                  solo
                  dense
                  v-model.trim="updateObject.first_name"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <!--  -->
            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("familyName") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>{{ general.family_name }}</p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == true" class="input-td">
                <v-text-field
                  solo
                  :rules="[validationRules.required, validationRules.spaces]"
                  v-model.trim="updateObject.family_name"
                  @focus="onFocus"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="details-table">
              <v-col cols="12" sm="3" md="3">
                <p class="main-color">
                  <strong>{{ $t("mobil") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" md="9" v-if="edit == false">
                <div>
                  <v-img
                    :src="general.country_code_flag"
                    width="20px"
                    style="display: inline-block; margin: 0 5px;"
                  ></v-img>
                  <span>
                    {{ general.mobile }}
                  </span>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="2"
                v-if="edit == true"
                class="countryCode"
              >
                <div class="code applicant-country-code" id="country-code">
                  <v-autocomplete
                    :items="dataObject.Codes"
                    class="form-control"
                    outlined
                    solo
                    @change="hideLabel = true"
                    item-text="title"
                    item-value="value"
                    value="187"
                    v-model="updateObject.country_code_id"
                    :rules="[validationRules.required]"
                    ><template slot="selection" slot-scope="data">
                      <v-flex xs2>
                        <!-- <v-avatar size="25px"> -->
                        <img :src="data.item.icon" class="flag-img" />
                        <!-- </v-avatar> -->
                      </v-flex>
                      <v-flex
                        :class="locale == 'en' ? 'margin-ltr' : 'margin-rtl'"
                      >
                        {{ data.item.title }}
                      </v-flex>
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- <v-list-item-avatar
                        style="width: 20px; min-width: 20px; height: 20px;"
                      > -->
                      <img :src="data.item.icon" class="flag-img" />
                      <!-- </v-list-item-avatar> -->
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="5"
                md="7"
                v-if="edit == true"
                class="input-td"
              >
                <v-text-field
                  solo
                  :rules="[validationRules.required, validationRules.numeric]"
                  v-model.trim="updateObject.mobile"
                  @focus="onFocus"
                ></v-text-field>

                <div
                  class="validationError"
                  v-if="validationErrors && validationErrors.mobile"
                >
                  <p
                    class="error--text backend-error"
                    v-for="(error, index) in validationErrors.mobile"
                    :key="index"
                  >
                    <span>{{ error }}</span>
                  </p>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("kind") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>
                  {{ $t(general.gender) }}
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == true" class="input-td">
                <v-radio-group
                  v-model="updateObject.gender"
                  :rules="[validationRules.required]"
                  row
                >
                  <v-radio :label="$t('male')" value="male"></v-radio>
                  <v-radio :label="$t('female')" value="female"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("dateOfBirth") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <span>{{ general.birthdate }} </span>
              </v-col>

              <v-col cols="12" sm="9" v-if="edit == true" class="input-td">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="updateObject.birthdate"
                      label
                      append-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                      :rules="[validationRules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="updateObject.birthdate"
                    @input="menu2 = false"
                    :max="nowDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("country/nationality") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>{{ general.nationality }}</p></v-col
              >
              <v-col cols="12" sm="9" v-if="edit == true" class="input-td">
                <v-select
                  solo
                  :items="dataObject.nationalities"
                  item-text="name"
                  item-value="id"
                  chips
                  :rules="[validationRules.required]"
                  v-model="updateObject.nationality_id"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="edit == true">
              <v-col :class="locale == 'en' ? 'text-right' : 'text-left'">
                <v-btn
                  class="primary-btn"
                  @click="update"
                  :loading="loading"
                  :disabled="loading"
                  >{{ $t("Update") }}</v-btn
                >
                <v-btn class="gray-btn" @click="cancelEdit">
                  {{ $t("Cancel") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from "../mixins/validationMixin";
import EditDeleteProfileImage from "./EditDeleteProfileImage";

export default {
  name: "studentGeneralInfo",
  mixins: [validationMixin],
  components: { EditDeleteProfileImage },
  props: ["general", "dataObject", "general_edit", "openEdit"],
  data() {
    return {
      loading: false,
      valid: false,
      validationErrors: [],
      updateObject: {
        first_name: "",
        family_name: "",
        gender: "",
        country_code_id: "",
        mobile: "",
        birthdate: "",
        nationality_id: ""
      },
      edit: false,
      str: "",

      nowDate: new Date(Date.now() - 864e5).toISOString().slice(0, 10),
      /* datepicker */
      date: new Date().toISOString().substr(0, 10),
      menu2: false
    };
  },
  methods: {
    onFocus() {
      this.validationErrors = [];
    },
    openEditMode() {
      this.edit = true;
      this.fillEditObject();
    },
    cancelEdit() {
      this.edit = false;
    },
    fillEditObject() {
      this.updateObject = {
        first_name: this.general.first_name,
        family_name: this.general.family_name,
        gender: this.general.gender,
        country_code_id: this.general_edit.country_code_id,
        mobile: this.general_edit.mobile,
        birthdate: this.general_edit.birthdate,
        nationality_id: this.general_edit.nationality_id
      };
    },
    update() {
      if (this.valid == false) {
        this.validate();
      } else {
        this.loading = true;
        this.$http
          .post(this.getApiUrl + "/student/profileData", this.updateObject, {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token
            }
          })
          .then(Response => {
            this.loading = false;
            // emit update to parent
            if (
              Object.keys(Response.data.status.validation_errors).length > 0
            ) {
              this.validationErrors = Response.data.status.validation_errors;
            } else {
              this.$emit(
                "updated",
                Response.data.status.error,
                Response.data.status.message
              );
              this.cancelEdit();
            }
          });
      }
    },

    getCountryCodes() {
      this.$http.get(this.getApiUrl + "/getCodes").then(response => {
        this.dataObject.Codes = response.data.data;
      });
    }
  },
  mounted() {
    this.getCountryCodes();
    if (this.openEdit == true) {
      this.openEditMode();
    }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";
@import "../assets/styles/_responsive.scss";

.profile-data {
  margin-top: 4rem;
  margin-bottom: 4rem;
  padding: 2rem;
  .primary-btn {
    background-color: $main-color !important;
  }
  .details-table {
    td {
      min-width: 200px;
      padding-bottom: 2rem;
    }
  }
}

.addEditProfileImage {
  position: relative;

  .profile-image {
    .v-image {
      max-width: 150px !important;
      width: 150px;
      height: 150px;
    }

    .edit-btn {
      top: -1rem !important;
    }
    .close-btn {
      top: 8rem !important;
    }
  }
}
</style>
